export default {
  testFun() {
    console.log("test fun success ...");
  },

  respH1(resp) {
    if (resp.status == 201) {
      return { success: true, msg: this.msgs.success_add, errors: [] };
    } else if (resp.status == 200) {
      return { success: true, msg: this.msgs.success_update, errors: [] };
    } else if (resp.status == 204) {
      return { success: true, msg: this.msgs.success_delete, errors: [] };
    } else if (resp.status == 410) {
      return { success: false, msg: this.msgs.forbidden, errors: [] };
    } else if (resp.status == 409) {
      return { success: false, msg: this.msgs.exists, errors: [] };
    } else if (resp.status == 422) {
      //return { success: false, errors: resp.data };
      return {
        success: false,
        msg: this.mergeErrors(resp.data),
        errors: this.mergeErrors(resp.data),
      };
      //return { success: false, errors: this.reshapeErrors(resp.data) };
    } else if (resp.status == 500) {
      return { success: false, errors: this.msgs.server_error };
    } else {
      return { success: false, errors: this.msgs.unknown_error };
    }
  },

  msgs: {
    success_add: "تمت الإضافة بنجاح",
    success_update: "تم التعديل بنجاح",
    success_delete: "تم الحذف بنجاح",

    server_error: "خطأ غير معروف",
    unknown_error: "خطأ مجهول",
    forbidden: "غير مسموح",
    exists: "موجود مسبقاً",
  },

  mergeErrors(errors) {
    let res = "";
    for (const field in errors) {
      errors[field].forEach((errorMsg) => {
        res += errorMsg + "\n";
      });
    }
    return res;
  },

  reshapeErrors(errors) {
    let res = [];
    for (const field in errors) {
      //if (errors.hasOwnProperty(field)) {
      errors[field].forEach((errorMsg) => {
        res.push(errorMsg);
      });
      //}
    }
    return res;
  },
};
